module.exports = __webpack_public_path__ + "7c963986f4760d5cb931554eb169876b.png";